import React, { useState, useEffect, Fragment } from 'react';
import {
    Row,
    Input,
    FormGroup,
    CustomInput,
    Button,
    ButtonGroup,
    Form,
    Modal,
    ModalBody,
    Label
} from 'reactstrap';
import {
    Colxx,
    Separator,
} from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { sortPropertyListByName } from '../../../../../../helpers/Utils';
import {
    gAPI_Property_List_By_Group,
    API_Email_Integration,
} from '../../../../../../constants/APIs';
import Axios from 'axios';
import Validation from '../../../../../../components/Validation';
export default function AddEmailIntegration({ visible, toggle }) {
    const [property, setProperty] = useState([]);
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState([]);
    const [inputData, setInputData] = useState({
        GroupId: getGroupID(),
        Name: 'Emails',
        Properties: [],
        SessionTimeoutInSeconds: 600,
        DefaultLanguage: 'en-US',
        IsReceivingEmail: false,
        IsRepliesEmail: false,
        IsTicketCopy: false,
        ReplyEmail: "",
        ForwardingEmail: "",
        EmailProvider: "Other"
    });

    useEffect(() => {
        AxiosAPI({
            method: 'get',
            url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
        })
            .then((res) => {
                setProperty([...res.data]);
            })
            .catch((err) => console.error(err));
    }, []);

    const handleChange = (e) => {
        setInputData({ ...inputData, [e.target.name]: e.target.value });
    };

    const handleCheckChange = (e) => {
        let filterList = [];
        if (e.target.checked) {
            filterList.push(e.target.value);
        }
        setInputData({ ...inputData, Properties: filterList });
    };

    const handleSave = async () => {
        /**  When creating a response for a integration, don't need pass a property id*/
        AxiosAPI({
            method: 'post',
            url: `${API_Email_Integration}`,
            data: inputData,
        }).then((res) => {
            if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                && res.data.Messages !== null && res.data.Messages.length > 0) {
                setMsg(res.data.Messages);
                setOpen(true);
            }
            else {
                toggle();
                setTimeout(() => {
                    window.location.reload();
                }, 300)
            }
        });
    };
    return (
        <Fragment>
            <Modal isOpen={visible} toggle={toggle}>
                <ModalBody>
                    <Row className="mb-4">
                        <Colxx xxs="12">
                            <div className="text-center">
                                <h6>Connect Email</h6>
                                <Separator className="mb-3" />
                                <Form>
                                    <FormGroup className="text-left mb-2">
                                        <Label>Integration Name</Label>
                                        <Input
                                            type="text"
                                            name="title"
                                            onChange={handleChange}
                                            placeholder="Enter your title"
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <div className='my-2 text-center'><h3>Select your business name</h3> </div>
                                        <div className='integration-property'>
                                            {sortPropertyListByName(property).map((p, index) => {
                                                return (
                                                    <CustomInput
                                                        key={p.id}
                                                        type="radio"
                                                        id={index}
                                                        value={p.id}
                                                        label={p.name}
                                                        //checked={inputData.Properties.filter((f) => p.id === f).length > 0 ? true : false}
                                                        onChange={handleCheckChange}
                                                    />
                                                );
                                            })}
                                        </div>
                                    </FormGroup>
                                </Form>
                                <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                                    <Button className="text-white" color="primary" size="xs" onClick={handleSave}>
                                        Get Started
                                    </Button>
                                    <Button size="xs" color="dark" outline onClick={toggle}>
                                        Cancel
                                    </Button>
                                </ButtonGroup>
                            </div>
                        </Colxx>
                    </Row>
                </ModalBody>
            </Modal>
            <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
        </Fragment>
    );
}